import { Mail, Phone, MapPin } from "lucide-react";
import { FaWhatsapp, FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";
import { BYMAT_LOGO } from "@/lib/brand";

const WHATSAPP_NUMBER = "919076104425";
const WHATSAPP_MSG = encodeURIComponent(
  "Hi Rahul, I'm interested in switching my career to GenAI Automation Testing. Please share the details!"
);

export default function Footer() {
  return (
    <footer className="relative border-t border-slate-800 bg-[#0A1628]" data-testid="footer-section">
      {/* WhatsApp floating button */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-20 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        data-testid="whatsapp-float-button"
        aria-label="WhatsApp us"
      >
        <FaWhatsapp className="w-7 h-7" />
      </a>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <img
            src={BYMAT_LOGO}
            alt="BYMAT Automation"
            className="h-28 w-auto mix-blend-screen"
            data-testid="footer-logo"
          />
          <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-sm">
            Helping manual testers to transform into Automation + AI careers
            with expert mentorship, real-world projects, and a supportive community.
          </p>

          <div className="flex items-center gap-3 mt-6">
            {[
              { Icon: FaLinkedin, href: 'https://www.linkedin.com/in/rahulganjare', label: "linkedin" },
              { Icon: FaInstagram, href: 'https://www.instagram.com/bymatautomation', label: "instagram" },
              { Icon: FaYoutube, href: 'https://www.youtube.com/@bymatautomation', label: "youtube" },
              { Icon: FaWhatsapp, href: `https://wa.me/${WHATSAPP_NUMBER}`, label: "whatsapp" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-slate-800 flex items-center justify-center text-slate-400 hover:text-[#38BDF8] hover:border-[#38BDF8]/40 transition-colors"
                data-testid={`social-${label}`}
                aria-label={label}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-white">
            Navigate
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li><a href="#curriculum" className="hover:text-[#38BDF8]">Curriculum</a></li>
            <li><a href="#coach" className="hover:text-[#38BDF8]">Mentor</a></li>
            <li><a href="#stories" className="hover:text-[#38BDF8]">Stories</a></li>
            <li><a href="#faq" className="hover:text-[#38BDF8]">FAQ</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-white">
            Contact
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#38BDF8]" />
              support@bymatautomation.com
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#38BDF8]" />
              +91-90761 04425
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#38BDF8]" />
              Lohgaon, Pune · Online via Zoom · Pan-India
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800 py-6 px-6 md:px-10 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500 max-w-7xl mx-auto">
        <div>© {new Date().getFullYear()} BYMAT Automation. All rights reserved.</div>
        <div className="mt-3 md:mt-0 flex gap-5">
          <a href="#" className="hover:text-[#38BDF8]">Privacy</a>
          <a href="#" className="hover:text-[#38BDF8]">Terms</a>
          <a href="/admin" className="hover:text-[#38BDF8]" data-testid="footer-admin-link">Admin</a>
        </div>
      </div>
    </footer>
  );
}
